class CachedValue {
  constructor(refresh) {
    this.updateCache = true;
    this.refresh = refresh;
  }
  get value() {
    if (this.updateCache || this.__value === void 0) {
      this.__value = this.refresh();
      this.updateCache = false;
    }
    return this.__value;
  }
}
var cachedValue_default = CachedValue;
export {
  cachedValue_default as default
};
